module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightmodsnow-81719cfff9cff80b96d38e852828e5e3.png";